document.addEventListener("DOMContentLoaded", function() {

    let home = document.getElementsByClassName('home');
    if(home.length && window.innerWidth > 1366){

        let logoPresentation = document.getElementsByClassName('logo-presentation');
        let scrollPresentation = document.getElementsByClassName('scroll-presentation');
        let elementBlockPresentation = document.getElementById('block-presentation');
        let elementLogo = logoPresentation[0];
        let elementScroll = scrollPresentation[0];

        if(window.scrollY > 0){
            elementLogo.style.cssText="opacity:0;";
            elementScroll.style.cssText="opacity:0;";
        }    

        //paralax
        const blockPresentation = document.getElementById('block-presentation');
        let blockParalax = blockPresentation.getElementsByClassName('block-presentation')[0];
        const initStyle = blockParalax.getAttribute('style');

        let startWidth = window.innerWidth;
        let endWidth = startWidth - 490;
        let startHeight = window.innerHeight;
        let endHeight = endWidth * 0.54;
        let startTop = -60;
        let startLeft = -430;

        /*console.log(startWidth);
        console.log(endWidth);
        console.log(startHeight);
        console.log(endHeight);
        console.log(startTop);
        console.log(startLeft);*/

        const ratio = 4;

        const distWidth = startWidth - endWidth;
        const distHeight = startHeight - endHeight;
        const distTop = Math.abs(startTop);
        const distLeft = Math.abs(startLeft);

        let stepWidth = distWidth / ratio;
        let stepHeight = distHeight / ratio;
        let stepTop = distTop / ratio;
        let stepLeft = distLeft / ratio;

        window.animParallax = {};

        if(!window.scrollY){
            document.body.style.cssText = 'overflow: hidden;';
            blockParalax.style.cssText = initStyle + 'position: absolute;width: '+startWidth+'px;height: '+startHeight+'px;top: '+startTop+'px;left: '+startLeft+'px;';

            window.animParallax.width = 0;
            window.animParallax.height = 0;
            window.animParallax.top = 0;
            window.animParallax.left = 0;
        } else {
            document.body.style.cssText = 'overflow: auto';
            blockParalax.style.cssText = initStyle + 'position: absolute;width: '+endWidth+'px;height: '+endHeight+'px;top: 0px;left: 0px; transition: initial;';

            window.animParallax.width = distWidth;
            window.animParallax.height = distHeight;
            window.animParallax.top = distTop;
            window.animParallax.left = distLeft;
        }

        let status = null;
        
        document.addEventListener('wheel', (e) => {
            if(e.wheelDelta < 0){
                status = 'down';
            } else {
                status = 'up';
            }

            if(!window.scrollY){
                if(status === 'down'){
                    stepWidth = Math.abs(stepWidth);
                    stepHeight = Math.abs(stepHeight);
                    stepTop = Math.abs(stepTop);
                    stepLeft = Math.abs(stepLeft);
                } else {
                    stepWidth = -Math.abs(stepWidth);
                    stepHeight = -Math.abs(stepHeight);
                    stepTop = -Math.abs(stepTop);
                    stepLeft = -Math.abs(stepLeft);
                }

                if(startWidth-window.animParallax.width <= startWidth && startWidth-window.animParallax.width >= endWidth ){
                    if(!((startWidth-window.animParallax.width === endWidth && stepWidth > 0) || (startWidth-window.animParallax.width === startWidth && stepWidth < 0))){
                        window.animParallax.width += stepWidth;
                        window.animParallax.height += stepHeight;
                        window.animParallax.top += stepTop;
                        window.animParallax.left += stepLeft;
                    }
                }

                /** Change opacity for logo and scroll icon
                 * depending on parallax position 
                 */
                var elementLogoOpacity = 1 - (window.animParallax.width / 430);;
                elementLogo.style.cssText="opacity:"+ elementLogoOpacity +";";
                elementScroll.style.cssText="opacity:"+ elementLogoOpacity +";";
                elementBlockPresentation.style.cssText='height:' + endHeight + 'px;';

                if(status === 'down'){
                    if(startWidth-window.animParallax.width === endWidth){
                        document.body.style.cssText = 'overflow: auto;';
                    }

                    blockParalax.style.cssText = initStyle + 'position:absolute;width:'+(startWidth-window.animParallax.width)+'px;height:'+(startHeight-window.animParallax.height)+'px;top:'+(startTop+window.animParallax.top)+'px;left:'+(startLeft+window.animParallax.left)+'px;';
                } else {
                    if(startWidth-window.animParallax.width >= endWidth){
                        document.body.style.cssText = 'overflow: hidden;';
                        blockParalax.style.cssText = initStyle + 'position:absolute;width:'+(startWidth-window.animParallax.width)+'px;height:'+(startHeight-window.animParallax.height)+'px;top:'+(startTop+window.animParallax.top)+'px;left:'+(startLeft+window.animParallax.left)+'px;';
                    }
                }
            }
        });
    }
});